import { handleActions } from '@gef-ui/utils/fsaActions';
import always from "ramda/es/always";
import append from "ramda/es/append";
import assoc from "ramda/es/assoc";
import evolve from "ramda/es/evolve";
import mergeDeepLeft from "ramda/es/mergeDeepLeft";
import o from "ramda/es/o";
import omit from "ramda/es/omit";
import uniq from "ramda/es/uniq";
import without from "ramda/es/without";
import isArray from "ramda-extension/es/isArray";
import { CACHE_KEY_PROP, actionTypes } from '../constants';
export const defaultState = {
    cache: {},
    requestCacheKeys: []
};
const setCachedRequest = (state, { payload })=>evolve({
        cache: assoc(payload.cacheKey, omit([
            CACHE_KEY_PROP
        ], payload)),
        requestCacheKeys: o(uniq, append(payload.cacheKey))
    })(state);
const updateCachedRequest = (state, { payload })=>evolve({
        cache: evolve({
            [payload.cacheKey]: mergeDeepLeft(omit([
                CACHE_KEY_PROP
            ], payload))
        })
    })(state);
const clearCachedRequest = (state, { payload })=>{
    const cacheKeysToOmit = isArray(payload) ? payload : [
        payload
    ];
    return evolve({
        cache: omit(cacheKeysToOmit),
        requestCacheKeys: without(cacheKeysToOmit)
    })(state);
};
export default handleActions({
    [actionTypes.SET_REQUEST]: setCachedRequest,
    [actionTypes.UPDATE_REQUEST]: updateCachedRequest,
    [actionTypes.CLEAR_REQUEST]: clearCachedRequest,
    [actionTypes.RESET]: always(defaultState)
}, defaultState);
